import { ChainId, Network, getNetworkFromChainId } from '@mprolab/sdk'
import { getBep20Contract } from './contractHelpers'
import { getSimpleRpcProviderByChainId } from './providers'
import type { MetaToken } from 'types/metaToken'
import { sanitizeMetaToken } from './tokenLogoUri'

function networkForChain(chainId: number): Network {
  return getNetworkFromChainId(chainId as ChainId) ?? Network.BASE
}

export async function resolveErc20MetaToken(
  tokenAddress: string,
  chainId: number,
): Promise<MetaToken> {
  const provider = getSimpleRpcProviderByChainId(chainId)
  const addr = tokenAddress.toLowerCase()
  const contract = getBep20Contract(addr, provider, chainId)
  try {
    const [symbol, name, decimals] = await Promise.all([
      contract.symbol(),
      contract.name(),
      contract.decimals(),
    ])
    return sanitizeMetaToken({
      address: addr,
      token: symbol,
      tokenName: name,
      decimals: Number(decimals),
      network: networkForChain(chainId),
      logoURI: '',
      chainId,
    })
  } catch {
    return sanitizeMetaToken({
      address: addr,
      token: '???',
      tokenName: 'Unknown token',
      decimals: 18,
      network: networkForChain(chainId),
      logoURI: '',
      chainId,
    })
  }
}
